import { render } from "./nhlTeamDetailDialog.vue?vue&type=template&id=70fbb897"
import script from "./nhlTeamDetailDialog.vue?vue&type=script&lang=js"
export * from "./nhlTeamDetailDialog.vue?vue&type=script&lang=js"

import "./nhlTeamDetailDialog.vue?vue&type=style&index=0&id=70fbb897&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__